// This file was automatically generated from appchart.refpanel.immunizations.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.immunizations');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.ptImmunizationDeclines');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.immunizations.triggers = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="immunization-buttons" class="el8LHSButtonContainer"><button type="button" class="el8button search-immunizations-trigger el8ItemButton el8Show ebs-btn ebs-btn-default" data-amplitude-source="clinical profile">Immunization Table</button><button type="button" class="el8button add-immunization-trigger el8ItemButton el8Show ebs-btn ebs-btn-default" data-amplitude-source="clinical profile">+ Add Vaccination</button></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.immunizations.checkHistoryTrigger = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<button type="button" class="el8button immunization-history-dialog-trigger el8ItemButton el8Show ebs-btn ebs-btn-default" data-amplitude-source="clinical profile" data-testid="immunization-history-dialog-open-button">Check Registry</button>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.immunizations.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var immList5284 = opt_data.immunizations;
  var immListLen5284 = immList5284.length;
  for (var immIndex5284 = 0; immIndex5284 < immListLen5284; immIndex5284++) {
    var immData5284 = immList5284[immIndex5284];
    output.append('<li class="el8BulletText el8ItemHover am-highlight more-actions-trigger" data-id="', soy.$$escapeHtml(immData5284.id), '"><div class="el8ItemButtonContainer"><button tabindex="-1" type="button" class="el8button el8ActionButton ebs-btn ebs-btn-default">Actions<span class="el8ButtonDropdownIcon"></span></button></div><span class="el8Preserve">');
    if (immData5284.modelClass == 'PatientImmunization') {
      output.append((soy.$$escapeHtml(immData5284.administeredDate)? el8.service.tz.soyDate(soy.$$escapeHtml(immData5284.administeredDate)) : ''), '  <a class="edit-text-trigger" data-id="', soy.$$escapeHtml(immData5284.id), '">', soy.$$escapeHtml(immData5284.vaccine.name), '</a>');
    } else if (immData5284.modelClass == 'PatientImmunizationDecline') {
      el8.template.ptdata.ptImmunizationDeclines.summary(immData5284, output);
    }
    output.append('</span></li>');
  }
  if (!opt_sb) return output.toString();
};
